import { PropsWithChildren } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { JiraLogo } from "@atlaskit/logo";

import { BlueWaveTemplate } from "@/components/signup/layouts/blue-wave-template";
import { ReturnToProduct } from "@/components/signup/site-activation/components/common/return-to-product";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { getFirstName } from "@/components/signup/utils/get-first-name";
import { useUserContext } from "@/components/user-context/user-context-provider";
import { Picture } from "@/components/wpl/image/src/image";

import { SquareVisaCiscoPfizer } from "../../components/square-visa-cisco-pfizer";

export const LoggedInJiraBlueWaveTemplateCurrentProductUser = ({
    productEditionText
}: PropsWithChildren<{ productEditionText: string }>) => {
    const { formatMessage } = useIntl();
    const {
        user: { name }
    } = useUserContext();

    return (
        <BlueWaveTemplate
            productEditionText={productEditionText}
            socialProofLogos={<SquareVisaCiscoPfizer />}
            tagline={formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira",
                defaultMessage: "Trusted by over 65,000 teams worldwide"
            })}
            valueProps={formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI",
                defaultMessage:
                    "Scale agile practices{newline}Consolidate workflows{newline}Expand visibility{newline}Plan, track, and release"
            }).split("{newline}")}
            productLogos={[
                <JiraLogo appearance="inverse" size="xlarge" key="jsm" />
            ]}
            illustration={
                <Picture
                    image={{
                        src: "https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png",
                        alt: ""
                    }}
                />
            }
            showAtlassianLogo={false}
        >
            <div css={containerCss}>
                <h2 css={siteActivationHeadingCss}>
                    {name
                        ? formatMessage(
                              {
                                  id: "BxpUiSignup.nameSite.header",
                                  defaultMessage: "Welcome back, {name}"
                              },
                              { name: getFirstName(name) }
                          )
                        : formatMessage({
                              id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                              defaultMessage: "Welcome back"
                          })}
                </h2>
                <SiteActivation
                    useContactExpandCohortLogic={true}
                    CurrentProductUser={<ReturnToProduct />}
                />
            </div>
        </BlueWaveTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "8px"
});

const siteActivationHeadingCss = css({
    fontSize: 24,
    fontWeight: 500,
    margin: 0,
    textAlign: "center"
});
